export default __webpack_public_path__ + "static/calm-pal-bff75183f516216f101edf03a0470eae.gif";